module.exports = __webpack_public_path__ + "static/img/rico-logo.e60c17fc.png";